// Admin → Activity Log (/admin-co/activity-log).
//
// The timeline that used to live here IS the shared component now — the PM,
// tester and developer dashboards render the same one. Keeping four copies of a
// 200-line timeline was how the old per-role pages drifted apart.
//
// Two things this page gains by moving over: filters and paging that run in SQL
// (it used to pull a hard-capped 500 rows and filter them in the browser, so the
// dropdowns only offered values from that page), and a project filter.
import PageHeader from "@/components/dashboard/PageHeader";
import AuditLogTable from "@/components/dashboard/AuditLogTable";

export default function ActivityLog() {
  return (
    <>
      <PageHeader
        title="Activity Log"
        subtitle="Every add, change and delete across your company — who did it, to what, and when."
      />
      <AuditLogTable
        title="Company activity"
        subtitle="Team changes, projects, staffing, test cases and runs."
      />
    </>
  );
}
